import { faBan, faCheck, faSpinner } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { useEffect, useState } from "react"
import { Button, ButtonGroup, Col, Form, Modal, Row, ToggleButton } from "react-bootstrap"
import { AdjustmentMode } from "./model"

interface AdjustmentModalProps {
  show: boolean
  onHide: () => void
  onAdjust: (amount: number, mode: AdjustmentMode) => Promise<void>
}

export const AdjustmentModal = ({ show, onHide, onAdjust }: AdjustmentModalProps) => {
  const [newAmount, setNewAmount] = useState<number>(0)
  const [loading, setLoading] = useState<boolean>(false)
  const [mode, setMode] = useState<AdjustmentMode>("set")

  const executeAdjustment = async () => {
    setLoading(true)
    try {
      await onAdjust(newAmount, mode)
      setLoading(false)
    } catch (e) {
      console.error(e)
    } finally {
      setLoading(false)
    }
    setNewAmount(0)
  }

  const keyDownHandler = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "-") {
      setMode("subtract")
      e.preventDefault()
    } else if (e.key === "+") {
      setMode("add")
      e.preventDefault()
    } else if (e.key === "=") {
      setMode("set")
      e.preventDefault()
    }
  }

  useEffect(() => {
    setMode("set")
    setNewAmount(0)
  }, [show])

  return <Modal show={show} onHide={onHide}>
    <Modal.Header closeButton>
      <Modal.Title>Adjust</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <Form onSubmit={(e) => { e.preventDefault(); executeAdjustment() }}>
        <Form.Group as={Row} className="mb-3" controlId="modal-adjustment-amount">
          <Form.Label column sm="2">Amount</Form.Label>
          <Col sm="10">
            <div className="d-flex gap-3">
              <ButtonGroup>
                <ToggleButton id="adjustment-mode-set" name="adjustment-mode" type="radio" value="set" variant="outline-primary" checked={mode === "set"} onChange={(e) => setMode(e.currentTarget.value as AdjustmentMode)}>=</ToggleButton>
                <ToggleButton id="adjustment-mode-add" name="adjustment-mode" type="radio" value="add" variant="outline-success" checked={mode === "add"} onChange={(e) => setMode(e.currentTarget.value as AdjustmentMode)}>+</ToggleButton>
                <ToggleButton id="adjustment-mode-subtract" name="adjustment-mode" type="radio" value="subtract" variant="outline-danger" checked={mode === "subtract"} onChange={(e) => setMode(e.currentTarget.value as AdjustmentMode)}>-</ToggleButton>
              </ButtonGroup>
              <Form.Control type="text" autoFocus onFocus={(e) => e.target.select()} defaultValue={newAmount} onKeyDown={keyDownHandler} onChange={(e) => setNewAmount(Number(e.target.value.replaceAll(",", ".").replaceAll(/[^0-9.]/g, "")))} isInvalid={isNaN(newAmount)} />
            </div>

            

          </Col>
        </Form.Group>
      </Form>
    </Modal.Body>
    <Modal.Footer>
      <Button variant="secondary" onClick={onHide}><FontAwesomeIcon icon={faBan} /> Cancel</Button>
      {loading ? <Button variant="primary" disabled={true}><FontAwesomeIcon icon={faSpinner} spin /> Adjusting...</Button> : <Button variant="primary" onClick={() => executeAdjustment()}><FontAwesomeIcon icon={faCheck} /> Adjust</Button>}
    </Modal.Footer>
  </Modal>
}
